/**
 * Constantes e utilidades para o módulo de Especificação de Embarcação
 */
import { FileText, Package, Wrench } from 'lucide-react';
import { processImageUrl } from '../../utils/imageConverter';

// Tipos de item do checklist
export const TIPOS_ITEM = {
  especificacao: { label: 'Especificação', icon: FileText, color: 'text-blue-600 bg-blue-50' },
  produto: { label: 'Produto', icon: Package, color: 'text-green-600 bg-green-50' },
  servico: { label: 'Serviço', icon: Wrench, color: 'text-orange-600 bg-orange-50' }
};

// Estado inicial para novo item
export const NOVO_ITEM_INICIAL = {
  descricao: '',
  categoria: 'Outros',
  tipo_item: 'especificacao',
  adicionar_ao_padrao: false
};

// Estado inicial para novo serviço
export const NOVO_SERVICO_INICIAL = {
  descricao: '',
  valor: '',
  fornecedor_id: '',
  observacao: ''
};

/**
 * Converte URL da imagem para URL direta
 * Suporta: URLs locais (/api/images/), AWS S3, Google Drive
 */
export const convertGoogleDriveUrl = (url) => {
  if (!url) return '';
  
  // Usar a função centralizada do imageConverter
  return processImageUrl(url);
};

/**
 * Calcula custo de um item específico do checklist
 */
export const getCustoItem = (item) => {
  let total = parseFloat(item?.custo_manual || 0) || 0;
  const list = Array.isArray(item?.itens_custo) ? item.itens_custo : [];
  list.forEach(ic => {
    total += parseFloat((ic && ic.valor_total) || 0) || 0;
  });
  return total;
};

/**
 * Custo comprado (real) de um item — soma dos valores efetivamente comprados via pedidos
 */
export const getCompradoItem = (item) => {
  const list = Array.isArray(item?.itens_custo) ? item.itens_custo : [];
  let total = 0;
  list.forEach(ic => {
    total += parseFloat((ic && ic.valor_real_total) || 0) || 0;
  });
  return total;
};

/**
 * Custo comprado (real) total da embarcação
 */
export const getCompradoTotal = (checklistItems) => {
  const list = Array.isArray(checklistItems) ? checklistItems : [];
  let total = 0;
  list.forEach(item => {
    total += getCompradoItem(item);
  });
  return total;
};

/**
 * Calcula custo total da embarcação
 */
export const getCustoTotal = (checklistItems) => {
  const list = Array.isArray(checklistItems) ? checklistItems : [];
  let total = 0;
  list.forEach(item => {
    total += getCustoItem(item);
  });
  return total;
};

/**
 * Calcula progresso do checklist
 */
export const getProgressoChecklist = (checklistItems) => {
  const list = Array.isArray(checklistItems) ? checklistItems : [];
  if (list.length === 0) return 0;
  const checked = list.filter(item => item?.status).length;
  return Math.round((checked / list.length) * 100);
};

/**
 * Conta itens sem fornecedor definido (independente de status).
 */
export const getItensSemFornecedor = (checklistItems) => {
  const list = Array.isArray(checklistItems) ? checklistItems : [];
  return list.filter(item => !item?.fornecedor_id).length;
};

/**
 * Agrupa itens por categoria preservando a ordem de primeira aparicao
 * (que corresponde a ordem definida no checklist do modelo).
 */
export const agruparPorCategoria = (checklistItems) => {
  const list = Array.isArray(checklistItems) ? checklistItems : [];
  const seen = new Set();
  const ordered = [];
  list.forEach(item => {
    const cat = (item && item.categoria) || 'Geral';
    if (!seen.has(cat)) {
      seen.add(cat);
      ordered.push(cat);
    }
  });
  return ordered;
};

/**
 * Formata valor monetário
 */
export const formatCurrency = (value) => {
  return (value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
};
